import { useState } from "react";
import { Tabs } from "antd";
import NominalCodeTabPage from "./tab";
import { NOMINAL_CODE_TYPES } from "../../../../constants/enum";

const NominalCodePage: React.FC = () => {
  const defaultTabKey = "1";
  const [activeKey, setActiveKey] = useState(defaultTabKey);

  const onChange = (newActiveKey: string) => {
    setActiveKey(newActiveKey);
  };

  const initialItems = [
    {
      label: "Debit",
      key: defaultTabKey,
      children: <NominalCodeTabPage type={NOMINAL_CODE_TYPES.DEBIT}/>,
    },
    {
      label: "Credit",
      key: "2",
      children: <NominalCodeTabPage type={NOMINAL_CODE_TYPES.CREDIT}/>,
    },
    {
      label: "Unders & Overs",
      key: "3",
      children: <NominalCodeTabPage type={NOMINAL_CODE_TYPES.UNDER_OVERS}/>,
    },
  ];

  return (
    <div className="page-master-data">
      <Tabs onChange={onChange} type="card" activeKey={activeKey} items={initialItems} destroyOnHidden />
    </div>
  );
};

export default NominalCodePage;
